var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15.825,
  height: 18.085,
  viewBox: "0 0 15.825 18.085"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_open-audio-spectrum",
  "data-name": "Icon open-audio-spectrum",
  d: "M9.043,0V18.085H11.3V0ZM4.521,2.261V15.825H6.782V2.261Zm9.043,2.261v9.043h2.261V4.521ZM0,6.782V11.3H2.261V6.782Z",
  fill: "currentColor"
})));
export { SvgVoice as ReactComponent };
export default __webpack_public_path__ + "static/media/voice.5034a45f541d19a7e7f965fafee8a5e8.svg";